var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGeo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 46,
    viewBox: "0 0 32 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9888 2C3.88237 2 1.97314 13.4486 1.97314 17.5744C1.97314 20.4048 3.24889 23.2401 3.88237 24.6529C7.61283 32.9436 13.8728 41.6254 15.5577 43.9034C15.782 44.2065 16.1911 44.2065 16.4155 43.9034C18.1004 41.6254 24.3603 32.9436 28.0908 24.6529C28.7287 23.2352 30 20.4048 30 17.5744C30 13.4486 28.0908 2 15.9844 2H15.9888Z",
    stroke: "#16AF8E",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9867 22.6354C18.9964 22.6354 21.4363 20.1332 21.4363 17.0467C21.4363 13.9601 18.9964 11.4579 15.9867 11.4579C12.9769 11.4579 10.537 13.9601 10.537 17.0467C10.537 20.1332 12.9769 22.6354 15.9867 22.6354Z",
    stroke: "#16AF8E",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeo);
export default __webpack_public_path__ + "static/media/geo.d90746af99c724753988f70e4d18b4c3.svg";
export { ForwardRef as ReactComponent };